import * as React from 'react'
import {useEffect, useRef, useState} from 'react'
import Button from '@components/common/button/button'
import './header.scss'
import TrafftLogo from '@images/logo/trafft-logo.svg'
import BurgerMenu from '@images/icons/burger-menu.svg'
import CloseIcon from '@images/icons/close.svg'
import Subscribe from '@images/header/subscribe-icon.svg'
import useOutsideClick from '@context/useOutsideClick';
import ArrowRight from '@images/icons/arrow.svg'
import ArrowDown from '@images/icons/arrow-down.svg'
import ArrowRightGray from '@images/icons/arrow-gray.svg'
import ArrowDownGray from '@images/icons/arrow-down-gray.svg'
import {Link} from "gatsby"
import {getRedirectionLink} from "@utils/redirectToTryForFree";
import {aboutUsItems, industries, resourcesItems, whiteLabelSolutions} from "@utils/headerDropdownData";
import ButtonLink from "../buttonLink/buttonLink";
import Cookie from "js-cookie";
import {pushToDataLayer} from "../../../utils/redirectToTryForFree";
import FloatingButton from "../floatingButton/floatingButton";
import {AnchorLink} from "gatsby-plugin-anchor-links";
import ScrollToTop from "../scrollToTop/scrollToTop";
import PromoBanner from "../promoBanner/promoBanner";

const Header = ({buttonType, page}) => {
  const [isNavExpanded, setIsNavExpanded] = useState(false)
  const [isIndustryDropdownExpanded, setIsIndustryDropdownExpanded] = useState(false)
  const [isFeaturesDropdownExpanded, setIsFeaturesDropdownExpanded] = useState(false)
  const [isResourcesDropdownExpanded, setIsResourcesDropdownExpanded] = useState(false)
  const [isAboutUsDropdownExpanded, setIsAboutUsDropdownExpanded] = useState(false)
  const trafftLoginUrl = `${process.env.GATSBY_SIGNUP_URL}login`
  const [loginUrl, setLoginUrl] = useState(trafftLoginUrl)
  const industriesOutsideClick = useRef();
  const featuresOutsideClick = useRef();
  const resourcesOutsideClick = useRef();
  const aboutUsOutsideClick = useRef();

  useOutsideClick(industriesOutsideClick, () => {
    setIsIndustryDropdownExpanded(false)
  });

  useOutsideClick(featuresOutsideClick, () => {
    setIsFeaturesDropdownExpanded(false)
  });

  useOutsideClick(resourcesOutsideClick, () => {
    setIsResourcesDropdownExpanded(false)
  });

  useOutsideClick(aboutUsOutsideClick, () => {
    setIsAboutUsDropdownExpanded(false)
  });

  const changeLoginUrl = () => {
    let url = ''
    if (Cookie.get('linkParameters') !== undefined) {
      url = `?${Cookie.get('linkParameters')}`
    }
    setLoginUrl(trafftLoginUrl + url)
  }

  useEffect(() => {
    changeLoginUrl()
  })

  const setIsOpen = () => {
    setIsNavExpanded(!isNavExpanded)
  }

  return (
    <header className='header-wrapper'>
      <div className='header-wrapper__header'>
        <div className='header-wrapper__header__up-header'>
          {page === 'agency' ?
            <>
              <ButtonLink
                href={`${process.env.GATSBY_AGENCY_SIGNUP}login`}
                type='bck-transparent'
                label="Log in"
                target="_blank"
              />
              <ButtonLink
                href={`${process.env.GATSBY_AGENCY_SIGNUP}signup`}
                onClick={pushToDataLayer}
                type='bck-transparent'
                label="Sign up"
                target="_blank"
              />
            </>
            :
            <>
              <ButtonLink
                href={loginUrl}
                type='bck-transparent'
                label="Log in"
                target="_blank"
              />
              <ButtonLink
                href={getRedirectionLink()}
                onClick={pushToDataLayer}
                type='bck-transparent'
                label="Sign up"
                target="_blank"
              />
            </>
          }
        </div>
        <div className='header-wrapper__header__menu'>
          <div className='header-wrapper__header__menu__logo'>
            <Link to={'/'}>
              <img src={TrafftLogo} alt='logo' loading="lazy"/>
            </Link>
          </div>
          <div className='header-wrapper__header__menu__right'>
            <div className="header-wrapper__header__menu__nav">

              <div className="header-wrapper__header__menu__nav__links">
                <div className="header-wrapper__header__menu__nav__links__dropdown" ref={featuresOutsideClick}>
                  <div
                    aria-hidden="true"
                    className="header-wrapper__header__menu__nav__links__dropdown__dropbtn"
                    onClick={() => {
                      setIsFeaturesDropdownExpanded(!isFeaturesDropdownExpanded);
                    }}>
                    Features
                    <img src={isFeaturesDropdownExpanded ? ArrowDown : ArrowRight} alt='logo' loading="lazy"/>
                  </div>
                  {isFeaturesDropdownExpanded &&
                    <>
                      <div className="header-wrapper__header__menu__nav__links__dropdown__content-platform">
                        <div
                          className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container'>
                          <p
                            className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__title'>
                            FEATURES AND INTEGRATIONS OVERVIEW
                          </p>
                          <div
                            className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container'>
                            <Link to="/features/" onClick={() => setIsFeaturesDropdownExpanded(!isFeaturesDropdownExpanded)}>
                              <div
                                className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features'>
                                <p
                                  className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__title'>
                                  All Features
                                </p>
                                <p
                                  className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__description'>
                                  Notifications, Time zones, Extras, Coupons, Refunds, and more
                                </p>
                              </div>
                            </Link>
                            <Link to="/features/#tab=integrations" onClick={() => setIsFeaturesDropdownExpanded(!isFeaturesDropdownExpanded)}>
                              <div
                                className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features'>
                                <p
                                  className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__title'>
                                  All Integrations
                                </p>
                                <p
                                  className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__description'>
                                  Whatsapp, Paypal, Teams, Zoom, Zapier, Google Calendar, and more
                                </p>
                              </div>
                            </Link>
                            <Link to="/reserve-with-google/" onClick={() => setIsFeaturesDropdownExpanded(!isFeaturesDropdownExpanded)}>
                              <div
                                className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features'>
                                <p
                                  className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__title'>
                                  Reserve with Google
                                </p>
                                <p
                                  className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__description'>
                                  Accept bookings via Google Search and Maps
                                </p>
                              </div>
                            </Link>
                            <Link to="/wordpress/" onClick={() => setIsFeaturesDropdownExpanded(!isFeaturesDropdownExpanded)}>
                              <div
                                className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features'>
                                <p
                                  className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__title'>
                                  WordPress Plugin
                                </p>
                                <p
                                  className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__description'>
                                  Add Trafft booking form to any page of your WordPress website
                                </p>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </div>
                  <Link
                    activeClassName="header-wrapper__header__menu__nav__links__link__active"
                    className='header-wrapper__header__menu__nav__links__link'
                    to='/demos'
                    partiallyActive
                  >
                    Demos
                  </Link>
                <div className="header-wrapper__header__menu__nav__links__dropdown" ref={industriesOutsideClick}>
                  <div
                    aria-hidden="true"
                    className="header-wrapper__header__menu__nav__links__dropdown__dropbtn"
                    onClick={() => {
                      setIsIndustryDropdownExpanded(!isIndustryDropdownExpanded);
                    }}>
                    Who’s it for
                    <img src={isIndustryDropdownExpanded ? ArrowDown : ArrowRight} alt='logo' loading="lazy"/>
                  </div>
                  {isIndustryDropdownExpanded &&
                   <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for">
                     <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__left-col">
                       <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__industry">
                         <p className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__industry__industry-items__section-title">Industry</p>
                         <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__industry__industry-items">
                           {industries.map((item) =>
                             <Link to={item.link} key={item.title} className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__industry__industry-items__link">
                               <img src={item.icon} alt=""/>
                               {item.title}
                             </Link>
                           )}
                         </div>
                       </div>
                       <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__book-a-demo">
                         <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__book-a-demo__cant-find-text">
                           <p className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__book-a-demo__cant-find-text__headline">Can’t find your industry?</p>
                           <p className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__book-a-demo__cant-find-text__desc">Book a demo to see if we’re a match!</p>
                         </div>
                         <Link to="/demo" aria-label="Schedule a demo">
                           <Button
                             id="demo-header-button"
                             type='ghost'
                             style={{width: '100%'}}
                             label='Book a Demo'
                           >
                           </Button>
                         </Link>
                       </div>
                     </div>
                     <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__right-col">
                       <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__industry">
                         <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__industry__industry-items">
                           <p className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__industry__industry-items__section-title">White Label Solutions</p>
                           {whiteLabelSolutions.map((item) =>
                             <Link to={item.link} key={item.title} className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__industry__industry-items__link header-wrapper__header__menu__nav__links__dropdown__who-is-it-for__industry__industry-items__link_light">
                               <img src={item.icon} alt=""/>
                               {item.title}
                             </Link>
                           )}
                         </div>
                       </div>
                      </div>
                   </div>
                  }
                </div>

                <div className="header-wrapper__header__menu__nav__links__dropdown" ref={resourcesOutsideClick}>
                  <div
                    aria-hidden="true"
                    className="header-wrapper__header__menu__nav__links__dropdown__dropbtn"
                    onClick={() => {
                      setIsResourcesDropdownExpanded(!isResourcesDropdownExpanded);
                    }}>
                    Resources
                    <img src={isResourcesDropdownExpanded ? ArrowDown : ArrowRight} alt='logo' loading="lazy"/>
                  </div>

                  {isResourcesDropdownExpanded &&
                    <div
                      className="header-wrapper__header__menu__nav__links__dropdown__content-resources">
                      <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__links">
                        <p className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__title'>{resourcesItems[0].name}</p>
                        <div className= 'header-wrapper__header__menu__nav__links__dropdown__content__section__pages'>
                          {resourcesItems[0].items.map((resource) => (
                            <a key={resource.name} href={resource.link}>
                              <div className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features'>
                                <div className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__icon-title'>
                                  <img src={resource.icon} alt=""/>
                                  <p
                                    className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__title'>
                                    {resource.name}
                                  </p>
                                </div>
                                <p className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__description'>
                                  {resource.description}
                                </p>
                              </div>
                            </a>
                          ))}
                        </div>
                      </div>
                      <form
                        action="https://acumbamail.com/newform/subscribe/ET8rshmNeLvQox6J8U99sSJZ8B1DZo1mhOgs408R0mHYiwgmM/31439/"
                        method="post"
                        className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form">
                        <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__heading">
                          <img src={Subscribe} alt='letter-icon'/>
                          <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__heading__title">
                            Subscribe to our newsletter
                          </div>
                          <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__heading__description">
                            Get the latest news to your email
                          </div>
                        </div>

                        <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__email-capture">
                          <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__email-capture__form-input">
                            <input id="r0c0m2i1" name="email_1" type="email" placeholder="Enter your email" required=""/>
                            <p><input type="text" name="a648267c" tabIndex="-1"
                                      style={{position: 'absolute', left: '-4900px'}}
                                      aria-hidden="true"
                                      id="a648267c"
                                      autoComplete="off" />
                            </p>
                            <p><input type="email" name="b648267c" tabIndex="-1"
                                      style={{position: 'absolute', left: '-5000px'}}
                                      aria-hidden="true"
                                      id="b648267c"
                                      autoComplete="off"/>
                            </p>
                            <p><input type="checkbox" name="c648267c" tabIndex="-1"
                                      style={{position: 'absolute', left: '-5100px'}}
                                      aria-hidden="true"
                                      id="c648267c"
                                      autoComplete="off"/>
                            </p>
                          </div>

                          <input type="hidden" name="ok_redirect" id="id_redirect"
                                 value=""/>
                          <input type="submit" value="Subscribe"
                                 className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__email-capture__form-button"/>
                        </div>
                      </form>
                    </div>
                  }
                </div>

                <div className="header-wrapper__header__menu__nav__links__dropdown" ref={aboutUsOutsideClick}>
                  <div
                    aria-hidden="true"
                    className="header-wrapper__header__menu__nav__links__dropdown__dropbtn"
                    onClick={() => {
                      setIsAboutUsDropdownExpanded(!isAboutUsDropdownExpanded);
                    }}>
                    About us
                    <img src={isAboutUsDropdownExpanded ? ArrowDown : ArrowRight} alt='logo' loading="lazy"/>
                  </div>
                  {isAboutUsDropdownExpanded &&
                    <div
                      className="header-wrapper__header__menu__nav__links__dropdown__content-about">
                      <div className='header-wrapper__header__menu__nav__links__dropdown__content-about__container'>
                        {aboutUsItems.map((aboutus) => (
                          aboutus.internal === true ?
                            <Link key={aboutus.name} to={aboutus.link} className='header-wrapper__header__menu__nav__links__dropdown__content-about__container__link' onClick={()=>setIsAboutUsDropdownExpanded(!isAboutUsDropdownExpanded)}>
                              <p
                                className='header-wrapper__header__menu__nav__links__dropdown__content-about__container__link__title'>
                                {aboutus.name}
                              </p>
                              <p className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__description'>
                                {aboutus.description}
                              </p>
                            </Link>
                            :
                            <a key={aboutus.name} href={aboutus.link} className='header-wrapper__header__menu__nav__links__dropdown__content-about__container__link'>
                              <p
                                className='header-wrapper__header__menu__nav__links__dropdown__content-about__container__link__title'>
                                {aboutus.name}
                              </p>
                              <p className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__description'>
                                {aboutus.description}
                              </p>
                            </a>
                        ))}
                      </div>
                    </div>
                  }
                </div>
                {page === 'agency' ?
                  <AnchorLink to="/white-label-booking-software/#agency-pricing" className='header-wrapper__header__menu__nav__links__link'>
                    Pricing
                  </AnchorLink>
                 :
                  <Link
                    activeClassName="header-wrapper__header__menu__nav__links__link__active"
                    className='header-wrapper__header__menu__nav__links__link'
                    to='/pricing/'
                    partiallyActive
                  >
                    Pricing
                  </Link>
                }
              </div>
            </div>
            <div className="header-wrapper__header__menu__nav-buttons">
              {page === 'agency' ?
                <a className="login_btn" href={`${process.env.GATSBY_AGENCY_SIGNUP}login`} target="_blank">Log in</a>
              :
                <a className="login_btn" href={trafftLoginUrl} target="_blank">Log in</a>
              }
                <Link to="/demo" id="demo-header" className="header-wrapper__header__menu__nav-buttons__book-a-demo tag-tracking-capterra" aria-label="Schedule a demo">
                  <Button
                    id="demo-header-button"
                    type={buttonType ? buttonType : 'primary'}
                    style={{width: '100%'}}
                    label='Book a Demo'
                  >
                  </Button>
                </Link>
              <div className="header-wrapper__header__menu__nav__burger"
                   aria-hidden="true"
                   onClick={() => {
                     setIsOpen();
                   }}
                   onKeyDown={setIsOpen}
              >
                <img src={isNavExpanded ? CloseIcon : BurgerMenu} alt='burger-menu' loading="lazy"/>
              </div>
            </div>
          </div>

        </div>
        {isNavExpanded &&
          <div className="header-wrapper__header__expanded">
            <div className='header-wrapper__header__expanded__menu'>
              <div className='header-wrapper__header__expanded__menu__logo'>
                <Link to={'/'}>
                  <img src={TrafftLogo} alt='logo' loading="lazy"/>
                </Link>
              </div>
              <div className="header-wrapper__header__expanded__menu__nav"
                   aria-hidden="true"
                   onClick={() => {
                     setIsOpen();
                   }}
                   onKeyDown={setIsOpen}
              >
                <a className="header-wrapper__header__expanded__menu__nav__mobile-link" href={trafftLoginUrl}
                   target="_blank"
                >
                  Log in
                </a>
                <img src={isNavExpanded ? CloseIcon : BurgerMenu} alt='burger-menu' loading="lazy"/>
              </div>
            </div>
            <div className="header-wrapper__header__expanded__menu__responsive">
              <div className="header-wrapper__header__expanded__menu__responsive__nav__links">
                <div className="header-wrapper__header__expanded__menu__responsive__nav__links__dropdown"
                     ref={featuresOutsideClick}>
                  <div
                    aria-hidden="true"
                    className="header-wrapper__header__expanded__menu__responsive__nav__links__dropdown__dropbtn"
                    onClick={() => {
                      setIsFeaturesDropdownExpanded(!isFeaturesDropdownExpanded);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });
                    }}>
                    Features
                    <img src={isFeaturesDropdownExpanded ? ArrowDownGray : ArrowRightGray} alt='logo' loading="lazy"/>
                  </div>
                  {isFeaturesDropdownExpanded &&
                    <div
                      className="header-wrapper__header__menu__nav__links__dropdown__content-platform-res">
                      <div
                        className='header-wrapper__header__menu__nav__links__dropdown__content-platform-res__section-container'>
                        <p
                          className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__title'>FEATURES AND INTEGRATIONS OVERVIEW</p>
                        <div
                          className='header-wrapper__header__menu__nav__links__dropdown__content-platform-res__section-container__items'>
                          <Link to="/features/">
                            <div
                              className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features'>
                              <p
                                className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__title'>
                                All Features
                              </p>
                            </div>
                          </Link>
                          <Link to="/features/#tab=integrations" onClick={() => setIsFeaturesDropdownExpanded(!isFeaturesDropdownExpanded)}>
                            <div
                              className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features'>
                              <p
                                className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__title'>
                                All Integrations
                              </p>
                            </div>
                          </Link>
                          <Link to="/reserve-with-google/">
                            <div
                              className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features'>
                              <p
                                className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__title'>
                                Reserve with Google
                              </p>
                            </div>
                          </Link>
                          <Link to="/wordpress/">
                            <div
                              className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features'>
                              <p
                                className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__title'>
                                WordPress Plugin
                              </p>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  }
                </div>
                <Link to='/demos' className='header-wrapper__header__expanded__menu__responsive__nav__links__shifted'>Demos</Link>
                <div className="header-wrapper__header__expanded__menu__responsive__nav__links__dropdown"
                     ref={industriesOutsideClick}>
                  <div
                    aria-hidden="true"
                    className="header-wrapper__header__expanded__menu__responsive__nav__links__dropdown__dropbtn"
                    onClick={() => {
                      setIsIndustryDropdownExpanded(!isIndustryDropdownExpanded);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });
                    }}>
                    Who’s it for
                    <img src={isIndustryDropdownExpanded ? ArrowDownGray : ArrowRightGray} alt='logo' loading="lazy"/>
                  </div>
                  {isIndustryDropdownExpanded &&
                    <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res">
                      <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res__industry">
                        <p className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res__industry__industry-links__title">Industry</p>
                        <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res__industry__industry-links">
                          {industries.map((item) =>
                            <Link to={item.link} key={item.title} className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res__industry__industry-links__link">
                              <img src={item.icon} alt=""/>
                              <p>
                                {item.title}
                              </p>
                            </Link>
                          )}
                        </div>
                        <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res__industry__demo">
                          <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res__industry__demo__text">
                            <p className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res__industry__demo__text__title">Can’t find your industry?</p>
                            <p className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res__industry__demo__text__desc">Book a demo to see if we’re a match!</p>
                          </div>
                          <Link to="/demo" aria-label="Schedule a demo">
                            <Button
                              id="demo-header-button"
                              type='ghost'
                              style={{width: '100%'}}
                              label='Book a Demo'
                            >
                            </Button>
                          </Link>
                        </div>
                      </div>
                      <div className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res__white-label">
                          <p className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res__industry__industry-links__title">White Label Solutions</p>
                          {whiteLabelSolutions.map((item) =>
                            <Link to={item.link} key={item.title} className="header-wrapper__header__menu__nav__links__dropdown__who-is-it-for-res__industry__industry-links__link">
                              <img src={item.icon} alt=""/>
                              <p>
                                {item.title}
                              </p>
                            </Link>
                          )}
                      </div>
                    </div>
                  }
                </div>
                <div className="header-wrapper__header__menu__nav__links__dropdown" ref={resourcesOutsideClick}>
                  <div
                    aria-hidden="true"
                    className="header-wrapper__header__menu__nav__links__dropdown__dropbtn"
                    onClick={() => {
                      setIsResourcesDropdownExpanded(!isResourcesDropdownExpanded);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });
                    }}>
                    Resources
                    <img src={isResourcesDropdownExpanded ? ArrowDownGray : ArrowRightGray} alt='logo' loading="lazy"/>
                  </div>

                  {isResourcesDropdownExpanded &&
                    <div
                      className="header-wrapper__header__menu__nav__links__dropdown__content-resources">
                      <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__links">
                        <p className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__title'>{resourcesItems[0].name}</p>
                        <div className= 'header-wrapper__header__menu__nav__links__dropdown__content__section__pages'>
                          {resourcesItems[0].items.map((resource) => (
                            <a key={resource.name} href={resource.link}>
                              <div className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features'>
                                <div className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__icon-title'>
                                  <img src={resource.icon} alt=""/>
                                  <p
                                    className='header-wrapper__header__menu__nav__links__dropdown__content-platform__section-container__features-container__features__title'>
                                    {resource.name}
                                  </p>
                                </div>
                              </div>
                            </a>
                          ))}
                        </div>
                      </div>
                      <form
                        action="https://acumbamail.com/newform/subscribe/ET8rshmNeLvQox6J8U99sSJZ8B1DZo1mhOgs408R0mHYiwgmM/31439/"
                        method="post"
                        className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form">
                        <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__heading">
                          <img src={Subscribe} alt='letter-icon'/>
                          <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__heading__title">
                            Subscribe to our newsletter
                          </div>
                          <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__heading__description">
                            Get the latest news to your email
                          </div>
                        </div>
                        <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__email-capture">
                          <div className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__email-capture__form-input">
                            <input id="r0c0m2i1" name="email_1" type="email" placeholder="Enter your email" required=""/>
                            <p><input type="text" name="a648267c" tabIndex="-1"
                                      style={{position: 'absolute', left: '-4900px'}}
                                      aria-hidden="true"
                                      id="a648267c"
                                      autoComplete="off" />
                            </p>
                            <p><input type="email" name="b648267c" tabIndex="-1"
                                      style={{position: 'absolute', left: '-5000px'}}
                                      aria-hidden="true"
                                      id="b648267c"
                                      autoComplete="off"/>
                            </p>
                            <p><input type="checkbox" name="c648267c" tabIndex="-1"
                                      style={{position: 'absolute', left: '-5100px'}}
                                      aria-hidden="true"
                                      id="c648267c"
                                      autoComplete="off"/>
                            </p>
                          </div>

                          <input type="hidden" name="ok_redirect" id="id_redirect"
                                 value=""/>
                          <input type="submit" value="Subscribe"
                                 className="header-wrapper__header__menu__nav__links__dropdown__content-resources__subscribe-form__email-capture__form-button"/>
                        </div>
                      </form>
                    </div>
                  }
                </div>

                <div className="header-wrapper__header__menu__nav__links__dropdown" ref={aboutUsOutsideClick}>
                  <div
                    aria-hidden="true"
                    className="header-wrapper__header__menu__nav__links__dropdown__dropbtn"
                    onClick={() => {
                      setIsAboutUsDropdownExpanded(!isAboutUsDropdownExpanded);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });
                    }}>
                    About us
                    <img src={isAboutUsDropdownExpanded ? ArrowDownGray : ArrowRightGray} alt='logo' loading="lazy"/>
                  </div>
                  {isAboutUsDropdownExpanded &&
                    <div
                      className="header-wrapper__header__menu__nav__links__dropdown__content-about">
                      <div className="header-wrapper__header__menu__nav__links__dropdown__content-about__container">
                        {aboutUsItems.map((aboutUs) => (
                          aboutUs.internal === true ?
                            <Link key={aboutUs.name} to={aboutUs.link} className='header-wrapper__header__menu__nav__links__dropdown__content-about__container__link'>
                              <p
                                className='header-wrapper__header__menu__nav__links__dropdown__content-about__container__link__title'>
                                {aboutUs.name}
                              </p>
                            </Link> :
                            <a key={aboutUs.name} href={aboutUs.link} className='header-wrapper__header__menu__nav__links__dropdown__content-about__container__link'>
                              <p
                                className='header-wrapper__header__menu__nav__links__dropdown__content-about__container__link__title'>
                                {aboutUs.name}
                              </p>
                            </a>
                        ))}
                      </div>
                    </div>
                  }
                </div>
                {page === 'agency' ?
                  <AnchorLink className='header-wrapper__header__expanded__menu__responsive__nav__links__shifted' to="/white-label-booking-software/#agency-pricing">
                    Pricing
                  </AnchorLink>
                  :
                  <Link to='/pricing/' className='header-wrapper__header__expanded__menu__responsive__nav__links__shifted'>Pricing </Link>
                }
              </div>
              <div className="header-wrapper__header__expanded__menu__responsive__nav-links-buttons">
                    <ButtonLink
                      href={getRedirectionLink()}
                      onClick={pushToDataLayer}
                      type='bck-transparent'
                      label="Sign up for free"
                      target="_blank"
                    />
                    <Link to='/demo' className="tag-tracking-capterra">
                      <Button
                        type={buttonType ? buttonType : 'primary'}
                        style={{width: '100%'}}
                        label='Book a Demo'
                      >
                      </Button>
                    </Link>
              </div>
            </div>
          </div>
        }
      </div>
      <FloatingButton
        page={page}
      />

      {page === 'docs' &&
        <ScrollToTop/>
      }
    </header>
  )
}

export default Header